var env = 'local';
var formFunctions = {

    endpoint: env == "local" ? "http://my.carshippingquote.dev/" : "https://my.carshippingquote.com/",
    formResponse: null,
    phoneResponse: null,
    phoneCount: 0,
    validationResponse: 0,
    typingTimer: 0,
    formSubmitted: 0,
    leadId: 0,

    loaderOn: function() {
        $body = $("body");
        $body.addClass("loading");
    },

    loaderOff: function() {
        $body = $("body");
        $body.removeClass("loading");
    },

    waitingForMatchFired: 0,

    waitingForMatch: function() {
        waitingDialog.show(
            this.waitingForMatchFired ? 'Reanalyzing your match criteria ' : 'Analyzing your match criteria ',
            {
                dialogSize: 'lg', progressType: 'success',
                onShow: function() {
                    var counter = 0;
                    var progressBar = $(document).find('.progress-bar');
                    progressBar.width("30%");

                    do {
                        var ran = Math.floor(Math.random()*(1-.5+.5)+.5);
                        counter += counter + ran;

                        progressBar.width(counter+"%");

                    } while(counter <= 100);
                    if(counter >= 100) {
                        setTimeout(function(){
                            waitingDialog.hide();
                        },1500);

                    }
                },
                onHide: function() {
                        $('.tab-linker-next:eq(0)').fadeIn(1000, function () {
                            $(this).attr('disabled', false);
                            $(this).removeClass('disabled');
                            if(!formFunctions.waitingForMatchFired) {
                                formFunctions.waitingForMatchFired = 1;
                                $(this).click();
                            }

                        })



                }
            }
        );



    },




    validatePhone: function(number) {

        $.ajax({
            type: "GET",
            url: "https://api2.irelocation.com/api/v1/validation/phone" + "/" + number + "+",
            dataType: "json",
            crossDomain: true,
            success: function (response, status, text) {
                if (response.status == 'success') {
                    phone.removeValidationError();
                    phone.style('valid').setData('valid',true);
                    phone.setData('phone-type', response);
                } else {
                    phone.style('error')
                        .setData('valid',false);
                    phone.setValidationError('In order to receive a quote estimate, please provide a valid and active number');
                }
            },
            error: function (request, status_text, error) {
                phone.style('error').setData('valid',false);
            }
        }).done();

    },

    validateEmail: function (value) {
        email.loaderOn();

        var api_key = 'pubkey-6b2335d110eda0d747869d83466016d3';
        var url = "https://api.mailgun.net/v2/address/validate?api_key=" + api_key + "&address=" + value;
        jqxhr = $.get(url, function (data) {
            $("#email_check").val("sent").trigger('change');
        })
            .done(function (response) {
                email.loaderOff();

                apiResponse = response;
                $("#email_check").val("done").trigger('change');

            })
            .fail(function () {

            })
            .always(function () {

            });
    },

    init: function(quoteForm) {
        this.setSource('source');
        this.setReferrer();
    },

    bwlCheck: function (value) {
        return (bwl.indexOf(value) == -1);
    },

    setReferrer: function () {
        if ($.cookie('campaign_referrer') == null) {
            $.cookie('campaign_referrer', document.referrer.split('/')[2]);
        }
    }
    , setSource: function (sParam) {
        var sPageURL = window.location.search.substring(1);
        var sURLVariables = sPageURL.split('&');
        for (var i = 0; i < sURLVariables.length; i++) {
            var sParameterName = sURLVariables[i].split('=');
            if (sParameterName[0] == sParam) {
                $.cookie('campaign_source', sParameterName[1]);
            }
        }
    }

    , getUrlParameter: function getUrlParameter(sParam) {
        var sPageURL = decodeURIComponent(window.location.search.substring(1)),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : sParameterName[1];
            }
        }
    },

    selectMatchingCompanies: function() {
        $("#matching-companies").fadeIn(1000,function() {
            $('#matching-count').countTo({
                from: 1,
                to: 3,
                speed: 1000,
                refreshInterval: 1,
                onComplete: function (value) {
                    $("#matching-companies").css('color', 'green');
                    formFunctions.selectQuoteRange();
                }
            });
        });
    },

    selectQuoteRange: function() {
        $("#quote-range").fadeIn(1500, function(){
            $(this).css('color', 'green');

            $('#provider-widget').removeClass('preloader2');
            $("#quote-monthly").fadeIn(1500, function(){
                $(this).css('color', 'green');

                $("#keep-going").fadeIn(500, function(){
                });
            });

        })

    },


    sendSms: function (id) {
        var test = $('input.test').val();
        var number = phone.field.val().replace(/\D/g, '');
        var url = "https://api2.irelocation.com/api/v1/sms-send/" + id + "/" + number + "/" + test;

        jqxhr = $.get(url, function (data) {
        })
            .done(function (response) {
                if(response.key !== "") {
                    window.location = "/thank-you?key=" + response.key;
                } else {
                    window.location = "/thank-you?key=not-found";
                }
            })
            .fail(function () {

            })
            .always(function () {

            });
    }
    , finalPhoneValid: function() {
        textVerify.data.number = phone.field.val().replace(/\D/g, '');
        this.validationResponse = true;
        phone.style('valid').setData('valid',true).setValid();
        formFunctions.submitForm();
    }

    , checkForm: function() {
        var check = [];
        $.each(validationObject,function(index,value) {
            if(value !== 1) {
                check.push(index);
            }
        });
    }

    , submitForm: function () {

            this.formSubmitted =1;

            var $form = $("#quote-form"),
                formData = new FormData(),
                params = $form.serializeArray();

            var $reason = ownerReason.getCheckedValues();

            $.each(params, function (i, val) {
                formData.append(val.name, val.value);
                if(val.name == "owner_reason") {
                    formData.append('owner_reason', $reason);
                }
            });

            $.ajax({
                url: '/quote/store',
                data: formData,
                cache: false,
                async: true,
                contentType: false,
                processData: false,
                type: 'POST',
                success: function (result) {



                    if(result.status=='success'){
                        clearStorage();
                        formFunctions.converted();
                    }
                }
            });


        return true;
    }

    , validator: function() {
        var $li = '';
        var $isValid = 1;
        if(firstName.field.val() < 2) {
            $li += formFunctions.generateErrorMessage(firstName);
            firstName.style('error');
            $isValid = 0;
        } else {
            firstName.style('valid');
        }
        if(lastName.field.val() < 2) {
            $li += formFunctions.generateErrorMessage(lastName);
            $isValid = 0;
            lastName.style('error');
        } else {
            lastName.style('valid');
        }

        if(!email.getData('valid')) {
            $li += formFunctions.generateErrorMessage(email);
            formFunctions.validateEmail(email.field.val());
            $isValid = 0;
        } else {
            email.style('valid');
        }
        if(!phone.getData('valid')) {
            $li += formFunctions.generateErrorMessage(phone);
            formFunctions.validatePhone(phone_user.field.val());
            $isValid = 0;
        } else {
            phone.style('valid');
        }

        if(!$isValid) {
            formFunctions.formSubmitted = 1;
            $(".fix-errors-message").fadeIn();
            $("#errors-list").html($li);
            return false;
        }

        return true;
    }

    , generateErrorMessage: function(object) {
        return '<li class="error_' + object.field.attr('id') +'">' + object.getData('message') + '</li>';
    }

    , validatorCheck: function() {

        var validForm = 1;
        var $li = "";
        $('#quote-form *').filter(':input.irelo-field').each(function(){
            var $field = getFieldObject($(this).attr('id'));
            if(!$field.getData('valid')) {
                validForm = 0;
                $field.style('error');
                $field.field.css("border", "1px solid " + theme_color_two);
                $li += '<li class="error_' + $field.field.attr('id') +'">' + $field.getData('message') + '</li>';
            }
        });

        if(validForm) {
            formFunctions.submitForm();
        } else {
            formFunctions.formSubmitted = 1;
            $(".fix-errors-message").fadeIn();
            $("#errors-list").html($li);
        }
    },

    converted: function() {
        //formFunctions.leadId = lead;
        $("#ptab3").fadeOut('slow');
        this.waitingForConfirmation();
    },


    waitingForConfirmation: function() {
        waitingDialog.show('Your information is being processed. Please wait...',
            {
                dialogSize: 'lg', progressType: 'success',
                onShow: function() {
                    var counter = 0;
                    var progressBar = $(document).find('.progress-bar');
                    progressBar.width("30%");

                    do {
                        var ran = Math.floor(Math.random()*(1-.5+.5)+.5);
                        counter += counter + ran;

                        progressBar.width(counter+"%");

                    } while(counter <= 100);
                    if(counter >= 100) {
                        setTimeout(function(){
                            waitingDialog.hide();
                        },1500);

                    }
                },
                onHide: function() {
                    window.location = "/thank-you?id=" + formFunctions.leadId;
                }
            }
        );
    },

    getCampaignVars: function() {
        $.cookie("source", source, { path: '/' });
        $.cookie("client_ip", client_ip, { path: '/' });
        $.cookie("referer", referer, { path: '/' });
    },

    setCampaignVars: function() {
        $("input[name='source']").val(
            $.cookie("referer") == "" ? "tma" : $.cookie("source")
        );
        $("input[name='client_ip']").val(
            $.cookie("referer") == "" ? "127.0.0.1" : $.cookie("client_ip")
        );
        $("input[name='referer']").val(
            $.cookie("referer") == "" ? "topmedicalalertcompanies.com" : $.cookie("referer")
        );
    }
};

formFunctions.setCampaignVars();

